<div [class]="addClass">
  <p class="mb-3">
    <a class="border-bottom" href (click)="onToggle(); false">
      {{ 'document-view-public.payment-qr.scan-to-pay' | translate }}
      <i class="fa fa-qrcode"></i>
    </a>
  </p>

  <ngx-qrcode
    *ngIf="show"
    [value]="qr"
    class=""
    errorCorrectionLevel="M"
    [margin]="0"
  ></ngx-qrcode>
</div>
